import {
  FormCell,
  Grid,
  ISelectOption,
  ISpruceFieldProps,
  NumberInputStyled,
  SelectField,
  SpruceField,
  TextField,
} from '../../../ui-toolkit';
import { NumberFormatValues } from 'react-number-format';
import React from 'react';
import { Show } from 'components/shared/Show';
import { ToggleTW } from 'tailwindComponents/toggleTW/ToggleTW';
import { StatesLabelValue } from '../../../ui-toolkit/enums/states';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';
import { IHasTestData } from '../../../ui-toolkit/test-utilities/IHasTestData';

interface SigningAppointmentAddressFormProps extends IHasTestData {
  showLocationToggle?: boolean;
  signerWillProvideLocation?: boolean;
  onToggleChange?: (value: boolean) => void;
  isLegacy?: boolean;
  isSignatureSync?: boolean;
}

export const SigningAppointmentAddressForm: React.FC<SigningAppointmentAddressFormProps> = ({
  showLocationToggle,
  signerWillProvideLocation,
  isLegacy = false,
  isSignatureSync = false,
  ...rest
}) => {
  const stateFilterOptions = (option: ISelectOption<string>, value: string) => {
    return option.value.toLowerCase().indexOf((value || '').toLowerCase()) >= 0;
  };
  const isRequired = (!signerWillProvideLocation && !isLegacy) || (isLegacy && isSignatureSync);
  return (
    <div data-test-id={mergeTests(rest['data-test-id'], 'signing-appointment-address-form')}>
      <div className={'mb-3 text-base font-semibold leading-6'}>Signing Location</div>

      <Show when={!!showLocationToggle}>
        <ToggleTW
          name="signerWillProvideLocation"
          text="Signer specifies location"
          data-test-id="signer-specifies-locaiton"
          className="mb-3"
        />
      </Show>

      <Show when={!signerWillProvideLocation}>
        <Grid templateColumns={'2fr 1fr'} className={'mb-2'}>
          <TextField
            isRequired={isRequired}
            name="address.streetAddress"
            placeholder={'Street Address'}
            label={`Signing Location`}
          />
          <TextField name="address.unit" placeholder={'Unit'} label={`Unit`} />
        </Grid>
        <Grid columnCount={3}>
          <TextField isRequired={isRequired} name="address.city" placeholder={'City'} label={`City`} />
          <SelectField
            name="address.stateAbbreviation"
            filterOption={stateFilterOptions}
            options={StatesLabelValue}
            isClearable={true}
            placeholder={'Select a State'}
            label={`State`}
            isRequired={isRequired}
          />
          <SpruceField name="address.zipCode">
            {({ field, formik }: ISpruceFieldProps) => (
              <FormCell errorText={field.errorText} label={`Zip Code`} isRequired={isRequired}>
                <NumberInputStyled
                  allowEmptyFormatting={false}
                  value={field.value}
                  format={`#####`}
                  type={'tel'}
                  placeholder={`12345`}
                  onBlur={() => formik.setFieldTouched(field.name)}
                  onValueChange={({ value }: NumberFormatValues) => {
                    formik.setFieldValue(field.name, value ? value : null);
                  }}
                />
              </FormCell>
            )}
          </SpruceField>
        </Grid>
      </Show>
    </div>
  );
};
